import React from "react";

const SupportPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <header className="bg-blue-600 text-white p-4 text-center">
        <h1 className="text-xl font-bold">Tarbaa Support / دعم ترَبَّع</h1>
      </header>

      <main className="container mx-auto mt-8 p-4 bg-white rounded shadow-lg">
        <h2 className="text-2xl font-semibold mb-4">
          How can we help you? / كيف يمكننا مساعدتك؟
        </h2>
        <p className="mb-2">
          Welcome to the Tarbaa support page. Here you can find answers to
          common questions, troubleshooting tips, and advice for getting the
          most out of our game.
          <br />
          مرحبًا بك في صفحة دعم ترَبَّع. هنا يمكنك العثور على إجابات للأسئلة
          الشائعة ونصائح لتحري الخلل وإصلاحه والنصائح للاستفادة القصوى من
          لعبتنا.
        </p>
        <h3 className="text-xl font-semibold mt-4">
          Frequently Asked Questions (FAQs) / الأسئلة المتكررة
        </h3>
        {/* Add your FAQs here */}
        <h3 className="text-xl font-semibold mt-4">
          Contact Support / تواصل مع الدعم
        </h3>
        <p>
          If you need further assistance, please don't hesitate to contact us at{" "}
          <a
            href="mailto:tarbaa.kw@gmail.com"
            className="text-blue-600 hover:text-blue-800"
          >
            tarbaa.kw@gmail.com
          </a>
          .<br />
          إذا كنت بحاجة إلى مزيد من المساعدة، لا تتردد في التواصل معنا على{" "}
          <a
            href="mailto:tarbaa.kw@gmail.com"
            className="text-blue-600 hover:text-blue-800"
          >
            tarbaa.kw@gmail.com
          </a>
          .
        </p>
      </main>

      <footer className="bg-gray-800 text-white text-center p-4 mt-8">
        <p>© 2025 ترَبَّع. All rights reserved. / جميع الحقوق محفوظة.</p>
      </footer>
    </div>
  );
};

export default SupportPage;
